<ng-container *ngIf="processoIdentificacaoPeticaoInicial != undefined">
  <div class="p-grid m-b-5">
    <div class="p-col-4 p-text-bold">Situacao:</div>
    <div class="p-col-8">
      {{processoIdentificacaoPeticaoInicial?.situacao | dominio:'getProcessoIdentificacaoPeticaoInicialSituacao'}}
    </div>
  </div>
  <div class="p-grid m-b-5">
    <div class="p-col-4 p-text-bold">Data Situação:</div>
    <div class="p-col-8">
      {{ processoIdentificacaoPeticaoInicial.dataSituacao |date: 'dd/MM/yyyy HH:mm:ss'}}
    </div>
  </div>
  <div class="p-grid m-b-5">
    <div class="p-col-4 p-text-bold">Modo:</div>
    <div class="p-col-8">
      {{processoIdentificacaoPeticaoInicial?.modo | dominio: 'getProcessoIdentificacaoPeticaoInicialModo'}}
    </div>
  </div>
  <div class="p-grid m-b-5">
    <div class="p-col-4 p-text-bold">Melhoria Continua</div>
    <span class="p-col-8">
     <ng-container *ngIf="!processoIdentificacaoPeticaoInicial.melhoriaContinuaPendenteEnvio && !processoIdentificacaoPeticaoInicial.melhoriaContinuaDataEnvio">
      <div>Não realizada</div>
    </ng-container>
    <ng-container *ngIf="processoIdentificacaoPeticaoInicial.melhoriaContinuaPendenteEnvio">
      <div>Pendente</div>
    </ng-container>
    <ng-container *ngIf="!processoIdentificacaoPeticaoInicial.melhoriaContinuaPendenteEnvio && processoIdentificacaoPeticaoInicial.melhoriaContinuaDataEnvio">
      <div>Realizado em: {{ processoIdentificacaoPeticaoInicial.melhoriaContinuaDataEnvio | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
    </ng-container>
    </span> <br>
  </div>
  <br>
  <p-tabView>
    <p-tabPanel header="Análise Automática">
      <div class="p-field">
        <app-processo-visualizador-dados-documento #dlgVlzDadosVisualizarPeticao> </app-processo-visualizador-dados-documento>
      </div>
      <div class="p-grid m-b-5">
        <div class="p-col-4 p-text-bold">Data:</div>
        <div class="p-col-8">
          {{ processoIdentificacaoPeticaoInicial.analiseAutomaticaData !== null ?
          (processoIdentificacaoPeticaoInicial.analiseAutomaticaData |date: 'dd/MM/yyyy HH:mm:ss') : '-' }}
        </div>
      </div>
      <div class="p-grid m-b-5">
        <div class="p-col-4 p-text-bold">Lote:</div>
        <div class="p-col-8">
          {{ processoIdentificacaoPeticaoInicial.analiseAutomaticaLoteAtual }}
        </div>
      </div>
      <div class="p-grid m-b-5">
        <div class="p-col-4 p-text-bold">Petição Inicial:</div>
        <div class="p-col-8" *ngIf="processoIdentificacaoPeticaoInicial.analiseAutomaticaPeticaoInicial?.nome == null; else nomePeticaoIniciaLink">
          Ausente
        </div>
        <ng-template #nomePeticaoIniciaLink>
          <div class="p-col-8">
            <a class="cursor-pointer"
               (click)="dlgVlzDadosVisualizarPeticao.visualizarDadosDocumentos(processoIdentificacaoPeticaoInicial.analiseAutomaticaPeticaoInicial,processoIdentificacaoPeticaoInicial.processo)">
              {{processoIdentificacaoPeticaoInicial.analiseAutomaticaPeticaoInicial?.nome }}
            </a>
          </div>
        </ng-template>
      </div>
      <p-table
        [value]="processoIdentificacaoPeticaoInicial?.analiseAutomaticaHistorico"
        *ngIf="processoIdentificacaoPeticaoInicial !== undefined"
        dataKey="data"
        responsive="true"
        responsiveLayout="scroll"
        styleClass="p-datatable-striped"
        sortMode="multiple"
        [paginator]="true"
        [rows]="15"
        [multiSortMeta]="[{field: 'data', order: -1}]">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th pSortableColumn="data">Data <p-sortIcon field="data"></p-sortIcon></th>
            <th>Lote</th>
            <th pSortableColumn="situacao">Situação <p-sortIcon field="situacao"></p-sortIcon></th>
            <th>Resultado</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-analiseAutomaticaHistorico let-expanded="expanded">
          <tr>
            <td>
              <button type="button" pButton pRipple [pRowToggler]="analiseAutomaticaHistorico"
                      class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
              </button>
            </td>
            <td>{{ analiseAutomaticaHistorico?.data | date: 'dd/MM/yyyy -  HH:mm:ss' }}</td>
            <td>{{ analiseAutomaticaHistorico?.lote }}</td>
            <td>{{ analiseAutomaticaHistorico?.situacao }}</td>
            <td>
              <ng-container [ngSwitch]="analiseAutomaticaHistorico?.situacao">
                <span *ngSwitchCase="'IDENTIFICADA'">{{analiseAutomaticaHistorico?.resposta.classeConvicto.codigo}}</span>
                <span *ngSwitchCase="'FALHA_PROCESSAMENTO'" style="color: #aa3000;">{{analiseAutomaticaHistorico?.erro}}</span>
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-analiseAutomaticaHistorico>
          <tr>
            <td colspan="7">
              <div class="p-p-3">
                <p-table
                  [value]="analiseAutomaticaHistorico?.resposta?.resultados"
                  dataKey="classe.descricao"
                  [paginator]="true"
                  [rows]="10">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width:300px;">Classe</th>
                      <th pSortableColumn="conviccao">Conviccao <p-sortIcon field="conviccao"></p-sortIcon></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-resultados>
                    <tr>
                      <td>{{resultados.classe.descricao}}</td>
                      <td>{{resultados.conviccao}}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="2">Não há resultados para esta situação.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">Não há informações disponíveis.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header=" Análise Manual">
      <div class="p-field">
        <app-processo-visualizador-dados-documento #dlgVlzDadosVisualizarPeticaoProcesso> </app-processo-visualizador-dados-documento>
      </div>
      <div *ngIf="processoIdentificacaoPeticaoInicial !== undefined">
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Situação:</div>
          <div class="p-col-8">
            <ng-container *ngIf="(processoIdentificacaoPeticaoInicial.analiseManualData |  date: 'dd/MM/yyyy HH:mm:ss') !== null; else naoRealizada">
              Realizada
            </ng-container>
            <ng-template #naoRealizada>Não realizada</ng-template>
          </div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Data:</div>
          <div class="p-col-8">
            {{ processoIdentificacaoPeticaoInicial?.analiseManualData ? (processoIdentificacaoPeticaoInicial.analiseManualData |  date: 'dd/MM/yyyy HH:mm:ss') : '-' }}
          </div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Usuário:</div>
          <div class="p-col-8">
            {{ processoIdentificacaoPeticaoInicial?.analiseManualUsuario?.nome ? processoIdentificacaoPeticaoInicial?.analiseManualUsuario?.nome : '-'}}
          </div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Petição inicial:</div>
          <div class="p-col-8">
            <ng-container *ngIf="processoIdentificacaoPeticaoInicial?.analiseManualData !== null">
              <ng-container *ngIf="processo?.peticaoInicial.id !== null; else mostrarAusente">
                <a class="cursor-pointer" (click)="dlgVlzDadosVisualizarPeticaoProcesso.visualizarDadosDocumentos(processo.peticaoInicial,processo)">
                  {{processo?.peticaoInicial?.nome}}
                </a>
              </ng-container>
              <ng-template #mostrarAusente>Ausente</ng-template>
            </ng-container>
            <ng-container *ngIf="processoIdentificacaoPeticaoInicial?.analiseManualData === null">-</ng-container>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</ng-container>

